import React, { useEffect, useState } from 'react'
import { GoLocation } from 'react-icons/go'
import { object, string } from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import {
  capitalize,
  schoolLevelsI18,
} from '../../../../utils/utils'

import * as s from './OfferInformation.styles'

const propTypes = {
  offer: object.isRequired,
  fontSize: string,
}

const defaultProps = {
  fontSize: '1em',
}

const OfferInformation = ({ offer, fontSize }) => {
  const { t } = useTranslation(['common'], { useSuspense: false })
  const { preferredLanguage } = useSelector((state) => state.talent)
  const [minimumSchoolLevel, setMininumSchoolLevel] = useState(null)

  useEffect(() => {
    if (offer?.schoolLevel?.length) {
      const levels = schoolLevelsI18(t)
      setMininumSchoolLevel(levels[Math.min(...offer.schoolLevel)])
    }
  }, [offer])

  return (
    <s.OfferInformationWrapper>
      <div className="info-wrapper">
        <span className="align-center filter">
          <GoLocation size={10} style={{ marginRight: 5 }} />{' '}
          {capitalize(offer?.location) || 'Non renseigné'}
        </span>
        {/* {offer?.experience?.length > 0 && (
          <span className="align-center filter">
            <MdWorkOutline size={10} style={{ marginRight: 5 }} />
            {experienceOptions(t)[offer.experience[0]]}
          </span>
        )} */}
      </div>
      {/* <div className="info-wrapper">
        {offer?.subJob?.length > 0 && (
          <span className="align-center filter">
            Profession : {offer.subJob.join(', ')}
          </span>
        )}
        {offer?.jobDomain?.length > 0 && !offer?.subJob?.length && (
          <span className="align-center filter">
            Domaine: {offer.jobDomain.join(', ').toLowerCase()}
          </span>
        )}
        {offer?.sector?.length > 0 && (
          <span className="align-center filter">
            Secteur : {offer.sector.join(', ')}
          </span>
        )}
      </div> */}
    </s.OfferInformationWrapper>
  )
}

OfferInformation.propTypes = propTypes
OfferInformation.defaultProps = defaultProps

export default OfferInformation
